import React, { ReactElement } from 'react';

import { Endpoint, Report, ReportService } from '@philips-emr/hpms-stipulator-commons';
import StipulatorContext from '@philips-emr/hpms-stipulator-commons/lib/contexts/stipulator-context';
import FilterService from '@philips-emr/hpms-stipulator-commons/lib/services/filter-service';
import { HPMSOnRenderAction } from '@philips-emr/hpms-stipulator-components/lib/events/event';
import { FetchAPI, InlineImage } from '@philips-emr/tws-components';
import Controller, { OnBeforeFetch, OnDynamicContentRender, OnMount, OnUnmount } from '@philips-emr/tws-core/lib/client';
import { MountEvent, RenderEvent } from '@philips-emr/tws-core/lib/component/types';

import { ConsultaCompartilhamentoRiscoAliases as Aliases, FragmentNames } from '../codegen';

import BaseController from './BaseController';
import { getLoteStampBySituacao, LoteSituacao } from './lote/lote-utils';

enum SituacaoCompartilhamento {
  FINALIZADO = 1,
  EFETIVADO = 2,
  PENDENTE = 3,
}

interface Data {
  dsSituacao: string;
  ieSituacao: SituacaoCompartilhamento;
  nrSeqRepasse: number;
}

@Controller({ fragment: FragmentNames.CONSULTA_COMPARTILHAMENTO_RISCO })
class ConsultarCompartilhamentoRiscoController extends BaseController {

  private reportService: ReportService;

  private exibirImprimir: boolean;

  @OnMount(Aliases.PANEL_COMPARTILHAMENTO_RISCO)
  onMountPanel(): void {
    void this.exibir().then((resp) => this.exibirImprimir = resp);
  }

  @OnMount(Aliases.FILTER_CONSULTA)
  onFilterMount(event: MountEvent): void {
    FilterService.restoreFilterState(event);
  }

  @OnUnmount(Aliases.FILTER_CONSULTA)
  onUnmountFilter(event: MountEvent): void {
    FilterService.persistFilterState(event);
  }

  @OnDynamicContentRender(Aliases.HPMS_DYNAMIC_CONTENT_SITUACAO)
  onDynamicContentRenderFieldSituacao(event: RenderEvent): void {
    const { data, render } = event;
    const { dsSituacao, ieSituacao } = data as Data;

    const situacaoMap = {
      [SituacaoCompartilhamento.FINALIZADO]: LoteSituacao.LIBERADO,
      [SituacaoCompartilhamento.PENDENTE]: LoteSituacao.AGUARDANDO_ACAO_DO_USUARIO,
      [SituacaoCompartilhamento.EFETIVADO]: LoteSituacao.INTEGRADO_A_PROPOSTA,
    };

    const content = (): ReactElement => (getLoteStampBySituacao(situacaoMap[ieSituacao], dsSituacao));

    render(content);
  }

  @HPMSOnRenderAction(Aliases.HPMS_CUSTOM_CARD)
  onRenderActionCustomCard(event: RenderEvent): void {
    const { data, render } = event;
    const { nrSeqRepasse } = data as Data;

    if (this.exibirImprimir) {
      const content = (): ReactElement => (
        <InlineImage
          className="u-hpms-clickable"
          src="/static/assets/hpms-print-gray.svg"
          onClick={() => this.imprimir(nrSeqRepasse)}
        />
      );
      render(content);
    }
  }

  @OnBeforeFetch(Aliases.FETCH_CONSULTA)
  onBeforeFetchBeneficiarios(event: MountEvent): void {
    const fetch = event.target as unknown as FetchAPI;
    const { nrSeqSubestipulante } = StipulatorContext.getCurrentContract();
    nrSeqSubestipulante && fetch.setParameters({ ...fetch.getParameters(), nrSeqSubestipulante });
  }

  private exibir = async (): Promise<boolean> => {
    const service = new ReportService('20', Endpoint.GET.RELATORIOS_POR_GRUPO);
    const relatorios = await service.getRelatoriosByCdGrupo() as unknown as Report[];
    const exibe = relatorios.length === 0 ? false : true;
    return exibe;
  };

  private imprimir(nrSeqRepasse: number): void {
    this.reportService = new ReportService('20', Endpoint.GET.RELATORIOS_POR_GRUPO);
    this.reportService.abreListaRelatorios({ NR_SEQUENCIA: nrSeqRepasse });
  }

}
export default ConsultarCompartilhamentoRiscoController;
